import type { Backend } from '@freelancer/datastore/core';
import {
  getQueryParamValue,
  OrderByDirection,
} from '@freelancer/datastore/core';
import type { UserEnterprisesCollection } from './user-enterprises.types';

export function userEnterprisesBackend(): Backend<UserEnterprisesCollection> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.ASC,
    },
    fetch: (authUid, ids, query, order) => ({
      endpoint: 'users/0.1/user_enterprises',
      params: {
        ids,
        users: getQueryParamValue(query, 'userId'),
        enterprises: getQueryParamValue(query, 'enterpriseId'),
        sources: getQueryParamValue(query, 'source'),
        offset: query?.searchQueryParams.offset,
        ignore_test_user: query?.searchQueryParams.ignoreTestUser,
      },
    }),
    push: undefined,
    set: undefined,
    update: undefined,
    remove: undefined,
  };
}
